/**
 * Used to track PromiseRejectionEvents
 */
export default class PromiseRejectionError extends Error {
  constructor(message) {
    super(message || 'Caught an unhandled promise rejection')
    this.name = 'PromiseRejectionError'
  }
}
